exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input.input[data-v-5643ad75]{outline:none;box-shadow:none;border:none;background-color:transparent;font-family:monospace;padding:0 .5ch;line-height:2em}.gap[data-v-5643ad75]:last-child{flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5643ad75&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/typing.vue
// module id = 19
// module chunks = 0